import React from 'react';
import _ from 'lodash';
import { Box, Grid, IconButton, AccordionSummary, FormControlLabel, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { MdOutlineEditCalendar } from 'react-icons/md';
import { JobsFieldSet } from '@rogoag/airtable/crm';
import { SchedulingRecordTypes } from '../../types/types';
import JobAndDropoffList from './JobAndDropoffList';
import { CustomCheckbox } from '../utils/CustomCheckbox';
import { LocalAtRecord, Job } from '../../db';
import MyAccordion from '../utils/MyAccordion';

type DayShiftProps = {
  dayShiftKey: string;
  scheduled: Record<string, SchedulingRecordTypes[]>;
  hiddenScheduled: string[];
  updateHiddenScheduled: (hidden: string[]) => void;
  selectedShift: string;
  updateSelectedShift: (shift: string) => void;
  updateZoomField: (zoomField: LocalAtRecord) => void;
  onRolloverShiftClick: () => void;
  onRolloverJobClick: (job: LocalAtRecord<JobsFieldSet>) => void;
  onAccordionToggle: () => void;
};

const DayShift: React.FC<DayShiftProps> = ({
  dayShiftKey,
  scheduled,
  hiddenScheduled,
  updateHiddenScheduled,
  selectedShift,
  updateSelectedShift,
  updateZoomField,
  onRolloverShiftClick,
  onRolloverJobClick,
  onAccordionToggle,
}) => {
  let totalAcres = 0;
  let numDropoffs = 0;
  scheduled[dayShiftKey].forEach((job) => {
    // TODO can we figure out how to type this correctly?...
    if (job.table === 'Jobs') {
      // Drew on 2025-09-29: for shifts, we should use "Ops acres Eq." over "Boundary Acres" (with bnd fallback)
      totalAcres += Job.getOpsAcresOrBoundaryAcresFromAtJob(job as LocalAtRecord<JobsFieldSet>);
    } else {
      numDropoffs += 1;
    }
  });

  const isVisible = hiddenScheduled.filter((hiddenKey) => hiddenKey === dayShiftKey).length ? true : false;

  const [date, robot, operator, rig] = dayShiftKey.split('/');
  //const dateObj = new Date(Date.parse(date));
  const labelText = `${date} <em>${robot}</em> <em>${rig}</em> <b>${operator}</b> -- <b>${Math.round(
    totalAcres,
  )}</b> Acres, <b>${scheduled[dayShiftKey].length - numDropoffs}</b> Jobs, <b>${numDropoffs}</b> Dropoffs`;
  const label = (
    <Typography align="left">
      <span key={dayShiftKey} dangerouslySetInnerHTML={{ __html: labelText }}></span>
    </Typography>
  );

  return (
    <Grid key={dayShiftKey} container style={{ marginBottom: 2 }} size={12}>
      <MyAccordion style={{ width: '100%' }} onChange={() => onAccordionToggle()}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <FormControlLabel
            onClick={(event) => event.stopPropagation()}
            onFocus={(event) => event.stopPropagation()}
            style={{ marginRight: 5 }}
            label={label}
            control={
              <CustomCheckbox
                checked={selectedShift === dayShiftKey}
                onChange={() => {
                  selectedShift !== dayShiftKey && updateSelectedShift(dayShiftKey);
                }}
              />
            }
          />

          {/* Right-aligned icon group — `marginLeft: auto` pushes to the right
              of the flex row, `flexShrink: 0` prevents collapse, replacing
              the prior `flex: 0` Grid which collapsed-and-overlapped in v7. */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: 'auto',
              flexShrink: 0,
            }}
          >
            <IconButton
              size="small"
              style={{ maxHeight: '20px' }}
              onClick={(event) => {
                event.stopPropagation();
                let hiddenScheduledCopy = hiddenScheduled.slice();

                if (isVisible) {
                  hiddenScheduledCopy = hiddenScheduledCopy.filter((hiddenKey) => hiddenKey !== dayShiftKey);
                } else {
                  hiddenScheduledCopy.push(dayShiftKey);
                }

                updateHiddenScheduled(hiddenScheduledCopy);
              }}
            >
              {isVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </IconButton>

            <IconButton
              size="small"
              style={{ maxHeight: '20px' }}
              onClick={(event) => {
                event.stopPropagation();

                if (selectedShift !== dayShiftKey) {
                  updateSelectedShift(dayShiftKey);
                }

                onRolloverShiftClick();
              }}
            >
              <MdOutlineEditCalendar color="#6643b5" />
            </IconButton>
          </Box>
        </AccordionSummary>

        <JobAndDropoffList
          list={scheduled[dayShiftKey]}
          updateZoomField={updateZoomField}
          onRolloverClick={(job: LocalAtRecord<JobsFieldSet>) => {
            if (selectedShift !== dayShiftKey) {
              updateSelectedShift(dayShiftKey);
            }

            onRolloverJobClick(job);
          }}
        />
      </MyAccordion>
    </Grid>
  );
};

export default DayShift;
